export default __webpack_public_path__ + "static/media/interacciones_medicamentosa.05ff93b0.svg";